import { types, applySnapshot } from 'mobx-state-tree';
import Framework from '@greenville/framework';
import * as constants from '../../../common/constants';

const typeString = types.model('typeString', {
  S: types.maybeNull(types.string)
});

const lastEvaluvatedKey = types.model('lastEvaluvatedKey', {
  bookId: types.maybeNull(typeString),
  serverDateTime: types.maybeNull(typeString),
  type: types.maybeNull(typeString),
  feedbackId: types.maybeNull(typeString),
  userId: types.maybeNull(typeString)
});

const ExclusiveStartKey = types.model('ExclusiveStartKey', {
  ExclusiveStartKey: types.optional(lastEvaluvatedKey, {})
});

const feedbackData = types.model('feedbackData', {
  bookId: types.maybeNull(types.string),
  serverDateTime: types.maybeNull(types.string),
  type: types.maybeNull(types.string),
  userId: types.maybeNull(types.string),
  title: types.maybeNull(types.string),
  comments: types.maybeNull(types.string),
  feedback: types.maybeNull(types.string),
  requestId: types.maybeNull(types.string),
  reasonForDisLike: types.optional(types.array(types.string), []),
  feedbackContent: types.maybeNull(types.optional(types.array(types.string), []))
});

const UserFeedbackModal = types
  .model('UserFeedbackModal', {
    data: types.optional(types.array(feedbackData), []),
    isNextPageKey: types.optional(ExclusiveStartKey, {})
  })
  .actions((self) => ({
    fetch(payload) {
      Framework.getEventManager().publish(constants.GET_USER_FEEDBACK_DATA, {
        payload
      });
    },
    setResponse(response) {
      applySnapshot(self, response.data);
      Framework.getEventManager().publish(constants.SET_USER_FEEDBACK_DATA);
    },
    resetStoreValues() {
      const initialState = [];
      applySnapshot(self.isNextPageKey, {});
      applySnapshot(self.data, initialState);
      Framework.getEventManager().publish(constants.SET_USER_FEEDBACK_DATA);
    }
  }));

export default UserFeedbackModal;
